module.exports = "<label for=\"logout\" (click)=\"logOut()\">Logout</label>\n"